import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-view-title',
  styleUrls: ['./view-title.component.scss'],
  templateUrl: './view-title.component.html',
})
export class ViewTitleComponent {
  @Input() title: string;
  @Input() subTitle: string;
}
